// extracted by mini-css-extract-plugin
export default {"icon":"icon--O9nbj","groupCaption":"groupCaption--CTO_z"};